import axios from "axios";
export function salesforceBannerAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage2Block1';
    axios.get(URL, config)
    .then(res => {
      //do something
     // console.log("SalesForce banner api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
}
export function dynamicsalesforceBannerAPI(config, callback, errorcallback,endpoint){
  const URL = process.env.REACT_APP_BASE_URL+endpoint;
    axios.get(URL, config)
    .then(res => {
      //do something
     // console.log("SalesForce banner api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
}
export function salesforceMetricAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage2Block2';
    axios.get(URL, config)
    .then(res => {
      //do something
      //console.log("salesForce Metric api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
  }
  export function cloudAPI(config, callback, errorcallback){
    const URL = process.env.REACT_APP_BASE_URL+'getPage2Block3';
    axios.get(URL, config)
    .then(res => {
      //do something
      //console.log("salesForce cloud api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
  }
  export function toolsTechAPI(config, callback, errorcallback){
    const URL = process.env.REACT_APP_BASE_URL+'getPage2Block4';
    axios.get(URL, config)
    .then(res => {
      //do something
     // console.log("salesForce cloud api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
  }
  export function DynamicServiceAPI(config, callback, errorcallback,endpoint){
    const URL = process.env.REACT_APP_BASE_URL+endpoint;
    axios.get(URL, config)
    .then(res => {
      //do something
      //console.log("salesForce cloud api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
  }
  export function ServiceAPI(config, callback, errorcallback){
    const URL = process.env.REACT_APP_BASE_URL+'getPage2Block7';
    axios.get(URL, config)
    .then(res => {
      //do something
      //console.log("salesForce cloud api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
  }
  export function PortfolioAPI(config, callback, errorcallback){
    const URL = process.env.REACT_APP_BASE_URL+'getPage2Block6';
    axios.get(URL, config)
    .then(res => {
      //do something
     // console.log("salesForce cloud api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
  }

  export function ServiceGlanceAPI(config, callback, errorcallback){
    const URL = process.env.REACT_APP_BASE_URL+'getPage13Block7';
    axios.get(URL, config)
    .then(res => {
      //do something
     // console.log("salesForce cloud api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
         errorcallback(err);
      }
    })
  }